import type { SVGProps } from 'react';

const SvgStorageOnPremise = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 3C7.53 3 3 4.37 3 7v10c0 2.63 4.53 4 9 4s9-1.37 9-4V7c0-2.63-4.53-4-9-4m0 2c4.55 0 7 1.42 7 2s-2.45 2-7 2-7-1.42-7-2 2.45-2 7-2m0 14c-4.55 0-7-1.42-7-2v-2.4c1.74.92 4.37 1.4 7 1.4s5.26-.48 7-1.4V17c0 .58-2.45 2-7 2m0-5c-4.55 0-7-1.42-7-2V9.6c1.74.92 4.37 1.4 7 1.4s5.26-.48 7-1.4V12c0 .58-2.45 2-7 2"
    />
  </svg>
);
export default SvgStorageOnPremise;
